import { BreakpointObserver } from "@angular/cdk/layout";
import { AfterViewInit, Component, HostListener, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { PasswordDialog } from "../components/_password-dialog/password-dialog";
import { GlobalSearchDialogService } from "../components/_global-search-dialog/global-search-dialog.service";
import { routeAnimation, slideInAnimation } from "../exports/animation";
import { menu } from "../exports/menu";
import { NotificationService } from "../services/notification.service";
import { ToolsService } from "../services/tools.service";
import { ThemeService } from "../services/theme.service";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.scss"],
  animations: [routeAnimation, slideInAnimation],
  standalone: false,
})
export class PagesComponent implements OnInit, AfterViewInit {
  lMenu = menu;
  oLogUser = JSON.parse(sessionStorage.getItem("Equora_User"));
  societe = null;
  opened: boolean = true;
  mode: any = "side";
  bOpenMobile = false;

  constructor(
    private _r: Router,
    private _ar: ActivatedRoute,
    private _dialog: MatDialog,
    private _bo: BreakpointObserver,
    public _tools: ToolsService,
    public _notifs: NotificationService,
    public _theme: ThemeService,
    private _globalSearch: GlobalSearchDialogService
  ) {
    this._r.events.subscribe((evt) => {
      // if (evt instanceof NavigationEnd) {
      //   this._notifs.get();
      // }
      window.scrollTo(0, 0); // Scroll jusqu'en haut de la page
    });
  }

  ngOnInit(): void {
    if (!this.oLogUser) {
      // Si pas connecté retour à la page Login
      this._r.navigate(["/"]);
    } else {
      this.societe = this.oLogUser.login_Base;
      // Vérification si l'utilisateur doit changer de mot de passe
      if (this.oLogUser.login_NewPassword) {
        this._dialog.open(PasswordDialog, {
          width: "500px",
          disableClose: true,
        });
      }
    }
  }

  ngAfterViewInit(): void {
    this._bo.observe(["(max-width: 1200px)"]).subscribe((res) => {
      if (res.matches) {
        this.mode = "over";
        this.opened = false;
        this._tools.bSmallScreen = true;
      } else {
        this.mode = "side";
        this.opened = true;
        this._tools.bSmallScreen = false;
      }
    });
  }

  logOutProcess(): void {
    sessionStorage.clear();
    localStorage.removeItem("Equora_Password");
    localStorage.removeItem("Equora_Remember");
    this._r.navigateByUrl("/");
  }

  showMenuLink(link: any): boolean {
    let show = true;
    return show;
  }

  prepareRoute(outlet: any) {
    // Retourne une valeur constante pour éviter l'erreur ExpressionChangedAfterItHasBeenCheckedError
    // L'animation routeAnimation fonctionne avec n'importe quelle transition '* => *'
    return "page";
  }

  openGlobalSearch(): void {
    this._globalSearch.openSearchDialog();
  }

  /** Ferme le drawer (side-nav) sur mobile après un clic sur un lien. */
  onNavLinkClick(): void {
    if (this._tools.bSmallScreen) this.opened = false;
  }

  @HostListener("document:keydown", ["$event"])
  onKeydown(e: KeyboardEvent): void {
    if (e.key !== "k") return;
    if ((e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      this.openGlobalSearch();
    }
  }
}
